import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3q1 .1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q0-1 1-1.1h.9m4.5-4.6q.9.1 1 1l.1.2V27q-.1 1-1.1 1.1h-.8q-1-.1-1.1-1v-8.4q.2-1 1.1-1zm4.5 1.6q1 .1 1.1 1v6.8q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1zM21.2 3.1q1.1 0 1.2 1.2v2H24c1.8 0 3.2 1.4 3.2 3.2v7.7l-1 .1q-.6-.9-1.4-1.3v-1.7h-4.4v2.3q-.9.8-.9 2.2v1.4h-1.4q-1 0-1.7.5H14v4h1v2.4H8A3 3 0 0 1 4.8 24V9.6c0-1.8 1.4-3.2 3.2-3.2h1.6v-2a1.2 1.2 0 1 1 2.4 0v2h8v-2q0-1.1 1.2-1.2M7.2 24q.1.7.8.8h3.6v-4H7.2zm0-5.6h4.4v-4H7.2zm6.8 0h4v-4h-4zM8 8.8q-.7.1-.8.8V12h17.6V9.6q-.1-.7-.8-.8z" })
});
export default SvgCalendarRegularReportIcon;
